import React from 'react';
import BulkUpdateRatesDialog, { ImportRateScope } from '../Utils/BulkUpdateRatesDialog';
import DefaultRatesTab from './BulkUpdateDefaultRatesTab';
import BranchBuyRatesTab from './BulkUpdateBranchBuyRatesTab';
import BranchClientSellRatesTab from './BulkUpdateBranchClientSellRatesTab';
import { TabProps } from './ScopedRateSharedTab';

export type { ImportRateScope };

const DIALOG_TITLE: Record<ImportRateScope, string> = {
  default: 'Import Default Buy & Sell Rates',
  buy: 'Import Branch Specific Buy Rates',
  sell: 'Import Branch/Client Specific Sell Rates',
};

const TAB_COMPONENT: Record<ImportRateScope, React.FC<TabProps>> = {
  default: DefaultRatesTab,
  buy: BranchBuyRatesTab,
  sell: BranchClientSellRatesTab,
};

interface Props {
  open: boolean;
  scope: ImportRateScope;
  handleClose: () => void;
}

export default function ConsumableBulkUpdateRatesDialog({ open, scope, handleClose }: Props) {
  return (
    <BulkUpdateRatesDialog
      open={open}
      scope={scope}
      handleClose={handleClose}
      dialogTitle={DIALOG_TITLE}
      tabComponent={TAB_COMPONENT}
    />
  );
}
